// Generated by purs version 0.15.15
var mkLoginController = function (env) {
    return env;
};
var documentationPath = "/documentation/drafting/frontend-program-builder/controllers/login_controller.md";
export {
    mkLoginController,
    documentationPath
};
//# sourceMappingURL=index.js.map
